import { Box, Button, Container, Paper, Stack, Typography } from "@mui/material"
import { useAuth } from "../hooks/useAuth"

function NoOrganizationAccess() {
  const { logout } = useAuth()
  return (
    <Box
      sx={{
        alignItems: "center",
        bgcolor: "background.default",
        display: "flex",
        minHeight: "100vh",
      }}
    >
      <Container maxWidth="sm">
        <Paper sx={{ p: 4 }}>
          <Stack spacing={2}>
            <Typography component="h1" variant="h5">
              Organization access required
            </Typography>
            <Typography color="textSecondary">
              You need to belong to an organization to access the MobileMind
              Data Portal.
            </Typography>
            <Box>
              <Button onClick={logout} variant="contained">
                Sign out
              </Button>
            </Box>
          </Stack>
        </Paper>
      </Container>
    </Box>
  )
}

export default NoOrganizationAccess
